import { render, staticRenderFns } from "./FormInputInteger.vue?vue&type=template&id=6a28d310&"
import script from "./FormInputInteger.vue?vue&type=script&lang=js&"
export * from "./FormInputInteger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports